import React from "react";
import { Box } from "@mui/material";
import ListItem from "./ListItem";
import { useLocation } from "react-router-dom";
import GroupIcon from "@mui/icons-material/Group";
import TranslateIcon from "@mui/icons-material/Translate";
import FaceIcon from "@mui/icons-material/Face";
import PsychologyIcon from "@mui/icons-material/Psychology";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
// import SmartToyIcon from "@mui/icons-material/SmartToy";

interface Item {
  id: number;
  icon: React.ElementType;
  text: string;
  href: string;
}

const items: Item[] = [
  {
    id: 1,
    icon: GroupIcon,
    text: "Clients",
    href: "/client",
  },
  {
    id: 2,
    icon: TranslateIcon,
    text: "Language",
    href: "/language",
  },
  {
    id: 3,
    icon: FaceIcon,
    text: "Avatar",
    href: "/avatar",
  },
  {
    id: 4,
    icon: PsychologyIcon,
    text: "STT Model Language",
    href: "/stt-model-language",
  },
  {
    id: 5,
    icon: FaceIcon,
    text: "Instant Speaker Language",
    href: "/instant-speaker-language",
  },
  {
    id: 6,
    icon: FaceRetouchingNaturalIcon,
    text: "TTS Emotion Config",
    href: "/tts-emotion-config",
  },
  // {
  //   id: 7,
  //   icon: SmartToyIcon,
  //   text: "Chatbot",
  //   href: "/chatbot",
  // },
];

const Sidebar: React.FC = () => {
  const location = useLocation();

  return (
    <Box
      sx={{
        height: "90vh",
        width: "10%",
        bgcolor: "#000",
        pt: 2,
        pb: 5,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
      }}
    >
      <Box mt={2}>
        <ul style={{ listStyle: "none", padding: 0 }}>
          {items.map((item) => (
            <ListItem
              key={item.id}
              id={item.id}
              icon={item.icon}
              text={item.text}
              href={item.href}
              isActive={location.pathname === item.href}
            />
          ))}
        </ul>
      </Box>
    </Box>
  );
};

export default Sidebar;
